<template>
  <div class="contaier">
    <!-- <div style="height: 300px; overflow: hidden">
    </div> -->
    <head-page></head-page>
    <div class="intro-box">
      <div class="img-box img-box_error" @click="handleClick">
        <img class="c-img" :src="newsDetail.img" />
      </div>
      <div class="hq-title1">{{ newsDetail.title }}</div>
      <div class="date-box">
        <div class="date">
          {{ newsDetail.createTime }}
        </div>
        <i class="iconfont icon-return" @click="goNewPage"></i>
      </div>
      <!-- <div class="img-box img-box_error" @click="handleClick">
        <img class="c-img" :src="newsDetail.img" />
      </div> -->
      <div class="intro">
        <div @click="handleClick2($event)" v-html="newsDetail.content"></div>
      </div>
    </div>

    <div
      class="dialog-box"
      @click="closeDialog"
      @wheel="(e) => e.preventDefault()"
      :class="{ 'dialog-box_show': photoDialog }"
    >
      <div class="dialog-img">
        <div class="close-btn">
          <i class="el-icon-close"></i>
        </div>
        <img class="img" @wheel="handleWheel" :src="dialogImageUrl" />
      </div>
    </div>
    <!-- width="640px" -->
    <!-- <el-dialog fullscreen :visible.sync="photoDialog">
      <div style="max-height: 70vh; overflow: auto">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </div>
    </el-dialog> -->
    <!-- ------------------------ 内 ** ------------------------ -->
    <footer-page></footer-page>
  </div>
</template>

<script>
import { activityTime } from "@/utils/utils";
import { imgBase, newsDetail } from "@/assets/js/static";
// import { contactList } from '@/assets/js/static'
// import { langMixins } from '@/mixins/langMixins'
import { newsDetailsApi } from "@/Api/requestApi";
import HeadPage from "@/components/HeadPage.vue";
import FooterPage from "@/components/FooterPage.vue";
// import 'swiper/css/swiper.css'
export default {
  name: "NewsView",
  // mixins: [langMixins],
  components: {
    HeadPage,
    FooterPage,
  },
  data() {
    return {
      // contactList: contactList.sort((a, b) => b.id - a.id),
      photoDialog: false,
      scale: 1,
      dialogImageUrl: "https://img.kamlung.net/hongqi/1784714404031291352629.jpg",
      refreshKey: 1,
      newsDetail: {
        titleImage: "",
        createTime: "2026/03/14",
        title: "家庭新硬派iCAR V27正式上市，售价16.98万元起",
        content: newsDetail,
      },
    };
  },
  mounted() {
    let id_ = this.$route?.query?.id;
    this.newsDetailsFn(id_);
    // console.log('id_ :>> ', id_)

    this.$nextTick(() => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  },
  methods: {
    async newsDetailsFn(id) {
      const {
        data: { code, data },
      } = await newsDetailsApi({ id });
      if (code == 200) {
        console.log("data :>> ", data);

        let { id, title, content, titleImage, createTime } = data[0];

        this.newsDetail = {
          id,
          createTime: activityTime(createTime),
          title: title,
          img: `${imgBase}${titleImage}`,
          content: content,
        };
        // console.log('data :>> ', data)
        console.log("this.newsDetail  :>> ", this.newsDetail);
      }
    },
    goNewPage() {
      // this.$router.go(-1)
      this.$router
        .push({ path: "/news", query: { lang: this.$i18n.locale } })
        .catch(() => {});
      //   this.$router
      //     .push({
      //       path: '/news',
      //       query: { lang: this.$i18n.locale },
      //     })
      //     .catch(() => {})
    },
    handleClick() {
      // console.log('e :>> -------', e.target.currentSrc)
      // console.log('e :>> -------', e)
      if (this.newsDetail?.img) {
        this.dialogImageUrl = this.newsDetail.img;
        this.photoDialog = true;
      }
      // console.log('e :>> -------', e.srcElement)
    },
    handleClick2(e) {
      // console.log('e :>> -------', e.target.currentSrc)
      // console.log('e :>> -------', e)
      if (e?.target?.currentSrc) {
        this.dialogImageUrl = e.target.currentSrc;
        this.photoDialog = true;
      }
      // console.log('e :>> -------', e.srcElement)
    },

    handleWheel(event) {
      // console.log('event :>> ', event)
      event.preventDefault(); // 阻止默认滚动行为，避免页面滚动
      const img = event.srcElement; // 获取 img 元素
      // const img = event.target.querySelector('img') // 获取 img 元素
      // console.log('img :>> ', img)
      if (!img) return;
      // const scaleStep = 0.1 // 每次滚轮滚动增加或减少的缩放比例
      const delta = event.deltaY * -0.001; // 根据滚轮方向和速度计算缩放因子
      this.scale = Math.min(Math.max(0.5, this.scale + delta), 2); // 限制缩放比例在0.1到5之间
      img.style.transform = `scale(${this.scale})`; // 应用缩放变换
    },
    closeDialog() {
      this.photoDialog = false;
      this.scale = 1;
    },
  },
};
</script>

<style scoped>
::v-deep .intro img {
  cursor: pointer !important;
  padding: 0 !important;
}
</style>

<style lang="scss" scoped>

.intro-box {
  ::v-deep img {
    width: 100%;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  ::v-deep .ql-size-large {
    font-size: 24px;
  }
  ::v-deep .ql-size-huge {
    font-size: 28px;
  }
}

.hq-title1 {
  // line-height: 90px;
  padding-bottom: 0;
  // padding-bottom: 40px;
  font-size: 36px;
  text-align: left;
  font-weight: 600;
}
.contaier {
  .dialog-box {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: none;
    background-color: rgba($color: #000000, $alpha: 0.8);
    z-index: 99999;
    .dialog-img {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .close-btn {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        font-size: 22px;
        color: #fff;
        background-color: #606266;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 20px;
        right: 30px;
        cursor: pointer;
        opacity: 0.8;
        z-index: 999999;
      }
      .img {
        transform: scale(0.91) rotate(0deg);
        max-height: 100%;
        // max-width: 100%;
        // height: 100%;
        width: auto;
      }
    }
  }
  .dialog-box_show {
    display: block;
  }
  .intro-box {
    max-width: 1100px;
    margin: 0 auto;
    padding: 100px 20px 120px 20px;

    //   padding-top: 240px;
    //   padding-bottom: 120px;
    //   .intro-1 {
    //     position: relative;
    //   }
    //   .intro- {
    //     width: 100%;
    //     position: absolute;
    //     top: 40px;
    //     left: 50%;
    //     transform: translateX(-50%);
    //     text-align: center;
    //     color: #fff;
    //     .intro {
    //       padding-top: 40px;
    //       max-width: 700px;
    //       margin: 0 auto;
    //       font-size: 16px;
    //     }
    //   }
    .intro {
      min-height: 380px;
      // max-width: 1200px;
      // margin: 0 auto;
      font-size: 18px;
      padding-bottom: 40px;
    }
    .date-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 20px;
      .date {
        font-size: 14px;
        text-align: right;
      }
      .icon-return {
        font-size: 26px;
        cursor: pointer;
        color: #666;
      }
    }

    .img-box {
      width: 100%;
      aspect-ratio: 16 / 10;
      margin-bottom: 20px;
      background-color: #f1f1f1;
      .c-img {
        aspect-ratio: 16 / 10;
        object-fit: cover;
        background-color: #fff;
      }
    }
  }
}

@media (max-width: 1400px) {
  // .hq-title1 {
  //   line-height: 60px;
  //   font-size: 26px;
  // }

  // .contaier {
  //   .intro-box {
  //     padding: 200px 20px 120px 20px;
  //     .intro {
  //       max-width: 1200px;
  //       margin: 0 auto;
  //       padding-bottom: 40px;
  //     }
  //     .img-box {
  //       aspect-ratio: 17 / 8.25;
  //       .c-img {
  //         aspect-ratio: 17 / 8.25;
  //       }
  //     }
  //   }
  // }
}
@media (max-width: 992px) {
  .hq-title1 {
    // line-height: 60px;
    font-size: 26px;
  }
  // .contaier {
  //   .intro-box {
  //     padding: 200px 20px 120px 20px;
  //     .intro {
  //       max-width: 1200px;
  //       margin: 0 auto;
  //       padding-bottom: 40px;
  //     }
  //     .img-box {
  //       aspect-ratio: 17 / 8.25;
  //       .c-img {
  //         aspect-ratio: 17 / 8.25;
  //       }
  //     }
  //   }
  // }
}

@media (max-width: 768px) {
  .hq-title1 {
    // line-height: 50px;
    font-size: 24px;
  }

  .contaier {
    .intro-box {
      padding: 160px 20px 80px 20px;
      .intro {
        padding-bottom: 40px;
      }
      .img-box {
        aspect-ratio: 16 / 16;
        .c-img {
          aspect-ratio: 16 / 16;
        }
      }

      // 手机端 table 图片每张独占一行
      ::v-deep table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
      }
      ::v-deep table td,
      ::v-deep table th {
        display: block;
        width: 100% !important;
      }
      ::v-deep table img {
        width: 100%;
        display: block;
      }
    }
  }
}
@media (max-width: 620px) {
  .hq-title1 {
    font-size: 22px;
  }
}
@media (max-width: 568px) {
  .hq-title1 {
    font-size: 22px;
  }
}
@media (max-width: 468px) {
  // .hq-title1 {
  //   font-size: 22px;
  // }
}
</style>
